import { EnvironmentModel } from "src/app/services/environment.service";


export const environment: EnvironmentModel = {
  production: false,
  baseUrl: 'https://api-qa2.b2bendix.com',
  naStoreUrl: 'https://qa2.b2bendix.com',
  emeaStoreUrl: 'https://qa2-mytruckservices.knorr-bremse.com',
  apacStoreUrl: 'https://qa2-apac-cvs.knorr-bremse.com',
  googleReCaptchaKey: '6LdC4kkqAAAAAEuDmkMpP4hf-E6k_6pjmYABn_LG',
  oneTrustKey: '9f2f4d2a-30fe-4273-852c-713da24b97c2-test',
  webtrekk: {
    trackId: "300480523804340",
    trackDomain: "knorrbremseglobal01.wt-eu02.net"
  },
  serverLoggingUrl: 'https://api-qa2.b2bendix.comocc/v2/NA/ui-logs'
};
